import type { NewsFilterState } from "@/utils/news";
import { regions } from "@/mocks/news";
import type { NewsType } from "@/types/news";

const timeOptions: { value: NewsFilterState["time"]; label: string }[] = [
  { value: "all", label: "全部时间" },
  { value: "1d", label: "最近一天" },
  { value: "3d", label: "最近三天" },
  { value: "7d", label: "最近一周" },
];

const typeOptions: { value: NewsType | "all"; label: string; icon: string }[] = [
  { value: "all", label: "全部", icon: "ri-apps-2-line" },
  { value: "text", label: "文字", icon: "ri-file-text-line" },
  { value: "image", label: "图片", icon: "ri-image-line" },
  { value: "video", label: "视频", icon: "ri-video-line" },
];

interface Props {
  value: NewsFilterState;
  onChange: (next: NewsFilterState) => void;
}

export default function FilterBar({ value, onChange }: Props) {
  return (
    <div className="space-y-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <span className="w-16 shrink-0 text-sm font-medium text-foreground-500">时间</span>
        <div className="flex flex-wrap gap-2">
          {timeOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange({ ...value, time: opt.value })}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                value.time === opt.value
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:text-primary-600"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <span className="w-16 shrink-0 text-sm font-medium text-foreground-500">类型</span>
        <div className="flex flex-wrap gap-2">
          {typeOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange({ ...value, type: opt.value })}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                value.type === opt.value
                  ? "bg-secondary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:text-secondary-700"
              }`}
            >
              <i className={opt.icon} />
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <span className="w-16 shrink-0 text-sm font-medium text-foreground-500">地区</span>
        <div className="flex flex-wrap gap-2">
          {["全部", ...regions].map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => onChange({ ...value, region: r })}
              className={`whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                value.region === r
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:text-accent-700"
              }`}
            >
              {r}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}